/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const RecycleBin: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M5 2.00488C5 0.897616 5.89826 0 6.99791 0H9.00209C10.1055 0 11 0.8939 11 2.00488V2.99512L11 3H14C14.5523 3 15 3.44772 15 4C15 4.55228 14.5523 5 14 5C14 4.9998 2.0128 5 2.0128 5C2.00583 5 2 5.99969 2 5.99969L2 5C1.44772 5 1 4.55228 1 4C1 3.44772 1.44772 3 2 3H5.00001L5 2.99512V2.00488ZM10 2.99512L9.99999 3H6.00001L6 2.99512V2.00488C6 1.45072 6.44973 1 6.99791 1H9.00209C9.55401 1 10 1.44698 10 2.00488V2.99512Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M2 5.99969C2 5.99989 13.9872 6 13.9872 6C13.9942 6 14 5 14 5V13.9972C14 15.1033 13.098 16 11.9915 16H4.00853C2.89925 16 2 15.1065 2 13.9972V5.99969ZM10 7.5C10 7.22386 10.2239 7 10.5 7C10.7761 7 11 7.22386 11 7.5V12.5C11 12.7761 10.7761 13 10.5 13C10.2239 13 10 12.7761 10 12.5V7.5ZM5.5 7C5.22386 7 5 7.22386 5 7.5V12.5C5 12.7761 5.22386 13 5.5 13C5.77614 13 6 12.7761 6 12.5V7.5C6 7.22386 5.77614 7 5.5 7Z'
			/>
		</Svg>
	);
};

export { RecycleBin };
